import { merge } from 'lodash';
import { from } from 'rxjs';

import { FetchError } from './types';

declare var API_ENDPOINT: string;

let token: any = null;

export const NETWORK_ERROR = Symbol('NetworkError');
export function api(uri: string, init: RequestInit = {}, fetcher = window.fetch, returnBlob: boolean = false) {
    return from(
        fetcher(
            `${API_ENDPOINT}${uri}`,
            merge(
                {
                    // credentials: 'include',
                    headers: {
                        Accept: 'application/json',
                        ...(token ? { Authorization: `Bearer ${token}` } : {}),
                    },
                },
                init,
            ),
        ).then(
            async response => {
                if (response.status >= 200 && response.status < 300) {
                    if (returnBlob) {
                        return await response.blob()
                    } else {
                        const body = await response.text();
                        try {
                            return JSON.parse(body);
                        } catch (error) {
                            return body;
                        }
                    }
                }
                const error = new Error(
                    `${response.status} - ${response.statusText}`,
                ) as FetchError;
                error.status = response.status;
                error.uri = uri;
                throw error;
            },
            error => {
                const httpFailure = error.status && !(error.status >= 200 && error.status < 300);
                if (!httpFailure) {
                    const httpError = new Error('Network error');
                    httpError[NETWORK_ERROR] = true;
                    throw httpError;
                }

                throw error;
            },
        ),
    );
}

export function registerToken(value: string | null) {
    token = value;
}

export function isNetworkError(error: Error) {
    return !!error[NETWORK_ERROR];
}

//(window as any).registerToken = registerToken;
